import React, { useCallback, useEffect, useState } from 'react'
import { Card, makeStyles, useMediaQuery } from '@material-ui/core'
import { useDropzone } from 'react-dropzone'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import { useDispatch } from 'react-redux'
import { setAgentDocuments } from 'src/lib/store'

interface SafeDropzoneProps {
  setSelectedFiles: (prevState: any) => void
  selectedFiles: any[]
}

export const SafeDropzone: React.FC<SafeDropzoneProps> = ({ setSelectedFiles, selectedFiles }) => {
  const [dragActive, setDragActive] = useState(false)
  const classes = useStyles()
  const device = useMediaQuery('(min-width:600px)') ? 'desktop' : 'mobile'
  const dispatch = useDispatch()

  const onDrop = useCallback(acceptedFiles => {
    acceptedFiles.forEach((f: File) => {
      const reader = new FileReader()
      reader.onloadend = () => setSelectedFiles((prevState: any) => [...prevState, { name: f.name, base64: reader.result }])
      reader.readAsDataURL(f)
    })
  }, [setSelectedFiles])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: 'image/*, application/pdf' })

  useEffect(() => {
    dispatch(setAgentDocuments(selectedFiles))
  }, [selectedFiles, dispatch])


  useEffect(() => {
    isDragActive ? setDragActive(true) : setDragActive(false)
  },[isDragActive])

  return (
    <Card {...getRootProps()} className={`${classes.dropzone} ${dragActive ? classes.dragActive : ''}`}>
        <input {...getInputProps()} aria-label='attachment picker' />
        {
          <div className="text-center">
            <p>{device === 'desktop' ? 'Drag \'n\' drop requested documents, or click to select files' : 'Attach Requested Documents'}</p>
            <AttachFileIcon />
          </div>
        }
      </Card>
  )
}

const useStyles = makeStyles({
  dropzone: { border: '2px dashed grey', padding: 10, cursor: 'pointer' },
  dragActive: { borderColor: '#43b146' }
})